import Firebase from "firebase/app";

import axios from "axios";
import store from "../store";

import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import "firebase/functions";

import config from "../../config.js";

const firebase = Firebase.initializeApp(config);
const baseUrlAlternative = config.baseUrlAlternative;

console.log(baseUrlAlternative);

export const db = Firebase.firestore();
export const FieldValue = Firebase.firestore.FieldValue;

if (config.dbSettings) {
  db.settings(config.dbSettings);
  console.log("Using local Firestore emulator");
}

export const httpBaseUrl = baseUrlAlternative;
export const storage = Firebase.storage();

export default {
  install: Vue => {
    const auth = firebase.auth();

    auth.onAuthStateChanged(auth => {
      store.dispatch("auth/auth", auth);
      store.dispatch("auth/loadUser", auth);
      store.dispatch("organizations/load");
      store.dispatch("meetings/load");
      store.dispatch("contracts/load");
    });

    Vue.prototype.$auth = {
      db,
      login: async ({ ssn }) => {
        try {
          const response = await axios.get(
            `${httpBaseUrl}/initiateAuth/${ssn}`
          );
          const id = response.data;

          const unsub = db
            .collection("authenticate")
            .doc(id)
            .onSnapshot(async doc => {
              const data = doc.data();

              if (data.customToken) {
                unsub();
                await auth.signInWithCustomToken(data.customToken);
              }
            });
        } catch (error) {
          console.log(error.message);
        }
      },
      loginQr: async () => {
        try {
          console.log("In QR-signin!");
          const response = await axios.get(`${httpBaseUrl}/initiateAuthQr`);
          const id = response.data;

          const unsub = db
            .collection("authenticate")
            .doc(id)
            .onSnapshot(async doc => {
              const data = doc.data();
              console.log("QR-Data!! ");
              console.log(data);
              if (data.status === "PENDING") {
                store.dispatch("auth/startQrUpdater", data);
              }
              if (data.status === "FAILED") {
                store.dispatch("auth/clearQrAndTimer");
              }
              if (data.status === "COMPLETED") {
                store.dispatch("auth/clearQrAndTimer");
                unsub();
                await auth.signInWithCustomToken(data.customToken);
              }
            });
        } catch (error) {
          console.log(error.message);
        }
      },
      cancelQr: () => {
        try {
          store.dispatch("auth/clearQrAndTimer");
        } catch (error) {
          console.log(error.message);
        }
      },
      logout: async () => {
        try {
          store.dispatch("auth/clearQrAndTimer");
          await auth.signOut();
        } catch (error) {
          console.log(error.message);
        }
      }
    };
    Vue.prototype.$cloud = {
      triggerPreliminaryElectionResult: async ({ meetingId, electionId }) => {
        try {
          const trigger = firebase
            .functions()
            .httpsCallable("triggerPreliminaryElectionResult", { timout: 900 });

          await trigger({
            meetingId: meetingId,
            electionId: electionId
          });
        } catch (error) {
          console.log("COULD NOT UPDATE ELECTION RESULTS");
          console.log(error.message);
        }
      }
    };
  }
};
